import React, { createContext, useContext } from "react";

import { RootStore } from "./root-store";

const StoreContext: React.Context<RootStore | null> = import.meta.hot?.data.storeContext ?? createContext<RootStore | null>(null);

if (import.meta.hot) {
  import.meta.hot.data.storeContext = StoreContext;
}

export function useStores() {
  const context = useContext(StoreContext);

  if (!context) {
    throw new Error("useStores must be used within a StoreProvider");
  }

  return context;
}

type StoreProviderProps = {
  onlyModels?: boolean;
  projectId: string;
  children: React.ReactNode;
};

export const StoreProvider: React.FC<StoreProviderProps> = ({ children, projectId, onlyModels = false }) => {
  const rootStore = React.useMemo(() => new RootStore(projectId, onlyModels), [projectId, onlyModels]);

  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>;
};
